export default {
      id: "eye-usage",
      viewBox: "0 0 22 17",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#eye",
      toString: function () {
        return this.url;
      }
    }